import React, { memo } from 'react';
import { withNativeProps } from '../../../utils/native-props';
export var SavePhotoIcon = /*#__PURE__*/memo(function (props) {
  return withNativeProps(props, /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "26",
    r: "24",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 14H14V38H33.7575L31.7575 36H22C22 29.3726 27.3726 24 34 24C34.6814 24 35.3496 24.0568 36 24.1659V28H38V14ZM19 22C19 20.3431 20.3431 19 22 19C23.6569 19 25 20.3431 25 22C25 23.6569 23.6569 25 22 25C20.3431 25 19 23.6569 19 22ZM33.7072 32.2929L36.0001 34.5858V30H38.0001V34.5858L40.293 32.2929L41.7072 33.7071L37.0001 38.4142L32.293 33.7071L33.7072 32.2929Z",
    fill: "white"
  })));
});